import { render, staticRenderFns } from "./PackageSelector.vue?vue&type=template&id=b9b81fc2&scoped=true&"
import script from "./PackageSelector.vue?vue&type=script&lang=js&"
export * from "./PackageSelector.vue?vue&type=script&lang=js&"
import style0 from "./PackageSelector.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PackageSelector.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./PackageSelector.vue?vue&type=style&index=2&id=b9b81fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b81fc2",
  null
  
)

export default component.exports